import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggleForm(event) {
    const checkbox = event.target
    const formId = checkbox.getAttribute("data-form-trigger")
    if (!formId) return

    const formElement = this.element.querySelector(`[data-form="${formId}"]`)
    if (!formElement) return

    formElement.classList.toggle("hidden", !checkbox.checked)
  }
}
